/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    currencies: {
        menu: {
            index: 'ارزها',
            create: 'ارز جدید',
            list: 'ارزها'
        },
        table_titles: {
            id: 'شناسه',
            name: 'نام',
            acronym: 'مخفف',
            symbol: 'نماد',
            decimals: 'تعداد اعشار',
            matchmaking_threshold: 'کرانه تطابق',
            is_fiat: 'نوع',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش ارز'
    }
}
